import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import {
  IconAdd,
  NamedLink,
} from '../../components';
import providerImg from '../../assets/pictures/womanProvider.png';
import childImg from '../../assets/pictures/child2.png';

import css from './SimulatorBanner.css';

const SimulatorBanner = props => {
  const { intl } = props;

  const titleHighlight = (
    <span className={css.titleHightlight}>
      {intl.formatMessage({ id: 'SimulatorPage.SimulatorBannerContentTitleSpan' })}
    </span>)
  const title = (<FormattedMessage id='SimulatorPage.SimulatorBannerContentTitle' values={{ highlight: titleHighlight }} />);
  const subtitle = intl.formatMessage({ id: 'SimulatorPage.SimulatorBannerContentText' });
  const ctaText = intl.formatMessage({ id: 'SimulatorPage.SimulatorBannerContentLink' });

  return (
    <section className={css.sectionMain}>
      <div className={css.mainContainer}>
        <div className={css.mainHeroContainer}>
          <div className={css.mainTitleContainer}>
            <span className={css.mainTitle}>{title}</span>
            <span className={css.mainSubtitle}>{subtitle}</span>
          </div>
          <div className={css.mainBackground}>
            <img className={css.providerImg} src={providerImg} alt='provider' />
            <img className={css.childImg} src={childImg} alt='child' />
            <NamedLink
              className={css.mainCTA}
              name='NewListingPage'
            >
              <span className={css.buttonText}>{ctaText}</span>
              <IconAdd className={css.buttonIcon} />
            </NamedLink>
          </div>
        </div>
      </div>

      <div className={css.mainContainerDesktop}>
        <div className={css.mainLeftContainer}>
          <div className={css.mainHeroContainerDesktop}>
            <div className={css.mainTitleContainer}>
              <span className={css.mainTitle}>{title}</span>
              <span className={css.mainSubtitle}>{subtitle}</span>
            </div>
            <NamedLink
              className={css.mainCTA}
              name='NewListingPage'
            >
              <span className={css.buttonText}>{ctaText}</span>
              <IconAdd className={css.buttonIcon} />
            </NamedLink>
          </div>
        </div>
        <div className={css.mainRightContainer}>
          <img className={css.providerImg} src={providerImg} alt='provider' />
          <img className={css.childImg} src={childImg} alt='child' />
        </div>
      </div>
    </section>
  )
}

export default injectIntl(SimulatorBanner);



// WEBPACK FOOTER //
// ./src/components/SimulatorBanner/index.js